import React ,{useEffect,useState}from "react";
import {
  Card,
  Typography,
  Stack,
  Box,
  CircularProgress,
  Grid,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { motion } from "framer-motion";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import LoopIcon from "@mui/icons-material/Loop";
import axios from "axios";
import { API_URL } from "../../Config/api";


const ServiceRing = ({ value, color, size = 40, thickness = 4, icon }) => {

 
  return (
    <Box
      sx={{
        position: "relative",
        width: 40,
        height: 40,
        borderRadius: "40%",
        border: `1px solid ${color}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mx: "auto",
      }}
    >
      {icon}
    </Box>
  );
};

const TotalServices = ({ services, tabValue }) => {
  //  const port  = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("accessToken");
  let dataForTab = {};
  if (tabValue === "1") {
    dataForTab = {
      completed: services.total_completed_servces_today || 0,
      pending: services.total_pending_service_today || 0,
      ongoing: services.total_ongoing_today || 0,
    };
  } else if (tabValue === "2") {
    dataForTab = {
      completed: services.total_completed_servces_this_month || 0,
      pending: services.total_pending_service_this_month || 0,
      ongoing: services.total_ongoing_this_month || 0,
    };
  } else if (tabValue === "3") {
    dataForTab = {
      completed: services.total_completed_servces_till_date || 0,
      pending: services.total_pending_service_till_date || 0,
      ongoing: services.total_ongoing_till_date || 0,
    };
  }

  const total =
    dataForTab.completed + dataForTab.pending + dataForTab.ongoing || 0;

  const cardSx = {
    flex: 1,
    display: "flex",
    flexDirection: "row", // 👈 horizontal card layout
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 160,
    px: 2,
    py: 2,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    borderRadius: { xs: 1, sm: 2 },
    backgroundColor: "#fff",
  };

  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [data, setData] = React.useState(0);  
    useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${API_URL}/web/save_website_count/`);
        console.log(response,'jjjjjjjj');
        setData(response.data.total_count);
        setIsLoading(false);
      } catch (error) {
        setError(error.message);
        console.log(error.message);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      {/* SERVICES TILL DATE CARD */}
      <Card
        sx={{
          backgroundColor: "#D0E5FF",
          height: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.5,
          px: 2,
          borderRadius: 1,
        }}
      >
        <Typography
          fontWeight="bold"
          sx={{ fontSize: { xs: 16, sm: 13, md: 16 } }}
          color="#6f42c1"
          textTransform="uppercase"
          textAlign="left"
        >
          Services Till Date
        </Typography>
        <Typography
          sx={{ fontSize: { xs: 16, sm: 13, md: 20 } }}
          color="primary"
          fontWeight="bold"
        >
          {data}
        </Typography>
      </Card>

      {/* MAIN SERVICES CARD */}
      <Card sx={{ ...cardSx, mt: 2, py: 3, px: 3 }}>
        <Stack spacing={3}>
          {/* Header */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              fontWeight="bold"
              color="#6f42c1"
              sx={{ fontSize: 18, textTransform: "uppercase" }}
            >
              Services
            </Typography>

            <Box textAlign="right">
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                color="text.secondary"
                sx={{ fontSize: { xs: 12, sm: 14, md: 14 } }}
              >
                Total Services
              </Typography>
              <Typography fontWeight="bold" color="#000000" fontSize={18}>
                {total}
              </Typography>
            </Box>
          </Stack>
          {/* Horizontal 3 Service Cards */}
          <Stack direction="row" spacing={2} justifyContent="space-between">
            {/* ✅ Completed */}
            <Card
              sx={{
                flex: 1,
                p: 2,
                textAlign: "center",
                backgroundColor: "#E8F5E9",
                borderRadius: 2,
                boxShadow: 3,
                transition: "transform 0.3s ease",
                "&:hover": { transform: "translateY(-4px)" },
              }}
            >
              <ServiceRing
                value={dataForTab.completed}
                // color="#4CAF50"
                icon={
                  <motion.div
                    initial={{ scale: 0.6, rotate: -20, opacity: 0 }}
                    animate={{ scale: 1, rotate: 0, opacity: 1 }}
                    transition={{ duration: 0.4, ease: "easeOut" }}
                    whileHover={{ scale: 1.2, rotate: 10 }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ fontSize: 40, color: "#4CAF50" }}
                    />
                  </motion.div>
                }
              />
              <Typography
                fontWeight="bold"
                fontSize={20}
                color="#4CAF50"
                mt={1}
              >
                {dataForTab.completed}
              </Typography>
              <Typography fontSize={13} fontWeight="600" fontFamily={"Roboto"}>
                Completed
              </Typography>
            </Card>

            {/* ⏳ Pending (smoothed) */}
            <Card
              sx={{
                flex: 1,
                p: 2,
                textAlign: "center",
                backgroundColor: "#FFF3E0",
                borderRadius: 2,
                boxShadow: 3,
                transition: "transform 0.3s ease",
                "&:hover": { transform: "translateY(-4px)" },
              }}
            >
              <ServiceRing
                value={dataForTab.pending}
                // color="#FFA500"
                icon={
                  <motion.div
                    animate={{ y: [0, -6, 0] }}
                    transition={{
                      repeat: Infinity,
                      duration: 1.6, // ⬅ slower and smoother
                      ease: "easeInOut",
                    }}
                  >
                    <HourglassTopIcon sx={{ fontSize: 40, color: "#FFA500" }} />
                  </motion.div>
                }
              />
              <Typography
                fontWeight="bold"
                fontSize={20}
                color="#FFA500"
                mt={1}
              >
                {dataForTab.pending}
              </Typography>
              <Typography fontSize={13} fontWeight="600" fontFamily={"Roboto"}>
                Pending
              </Typography>
            </Card>

            {/* 🔄 Ongoing */}
            <Card
              sx={{
                flex: 1,
                p: 2,
                textAlign: "center",
                backgroundColor: "#FFFDE7",
                borderRadius: 2,
                boxShadow: 3,
                transition: "transform 0.3s ease",
                "&:hover": { transform: "translateY(-4px)" },
              }}
            >
              <ServiceRing
                value={dataForTab.ongoing}
                // color="#FFD600"
                icon={
                  <motion.div
                    animate={{ initial: { y: 0 }, animate: { y: [0, 1, 0.5] } }}
                    transition={{
                      duration: 1,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <LoopIcon sx={{ fontSize: 40, color: "#FFD600" }} />
                  </motion.div>
                }
              />
              <Typography
                fontWeight="bold"
                fontSize={18}
                color="#FFD600"
                mt={1}
              >
                {dataForTab.ongoing}
              </Typography>
              <Typography fontSize={13} fontWeight="550" fontFamily={"Roboto"}>
                Ongoing
              </Typography>
            </Card>
          </Stack>
        </Stack>
      </Card>
    </>
  );
};

export default TotalServices;
